import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import PortfolioSummary from "../components/PortfolioSummary"

export const IndexPageTemplate = ({ title, tagline, service, cta }) => (
  <React.Fragment>
    <section id="banner">
      <div class="content">
        <div class="inner">
          <header>
            <h2>{title}</h2>
            <p>{tagline}</p>
          </header>
        </div>
      </div>
    </section>

    <section class="wrapper">
      <div class="inner">
        <ul class="features">
          <li>
            <h3 class="icon style1 solid fa-wrench">{service.title}</h3>
            <p>{service.intro}</p>
            <Link to={service.link} className="button">
              Learn More
            </Link>
          </li>
        </ul>
      </div>
    </section>

    <section id="two" class="wrapper cta">
      <div class="inner">
        <header>
          <h2>{cta.title}</h2>
          <p>{cta.text}</p>
          <ul class="actions">
            <li>
              <Link to="contact" className="button huge">
                Get in touch
              </Link>
            </li>
          </ul>
        </header>
      </div>
    </section>

    <PortfolioSummary />
  </React.Fragment>
)

IndexPageTemplate.propTypes = {
  title: PropTypes.string,
  tagline: PropTypes.string,
  service: PropTypes.object,
  cta: PropTypes.object,
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout isHome={true}>
      <IndexPageTemplate
        title={frontmatter.title}
        tagline={frontmatter.tagline}
        service={frontmatter.service}
        cta={frontmatter.cta}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}
export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        tagline
        service {
          intro
          title
          link
        }
        cta {
          title
          text
        }
      }
    }
  }
`
